import { useState } from "react"
import { motion } from "framer-motion"

const FAQ_ITEMS = [
  {
    question: "如何訂購這款冠軍限定香氛？",
    answer:
      "請先完成銀行轉帳，再填寫訂購人資料、匯款確認與 7-ELEVEN 店到店資訊。我們核對款項無誤後，會依訂單順序安排出貨。",
  },
  {
    question: "付款方式與金額怎麼計算？",
    answer:
      "目前只提供銀行轉帳。售價 NT$1,280 已含 7-ELEVEN 店到店運費，匯款金額請依訂購組數計算，無須另加運費。",
  },
  {
    question: "收件方式是什麼？",
    answer:
      "全館採 7-ELEVEN 店到店寄送。請填寫正確的門市名稱與地址，以利順利寄達。",
  },
  {
    question: "訂單成立後，多久會出貨？",
    answer:
      "訂單送出後會寄送 Email，確認我們已收到您的訂單資訊。待核對匯款無誤，將依付款順序安排出貨。",
  },
  {
    question: "全球限量 500 組售完後會補貨嗎？",
    answer:
      "《馴養一朵風》為 CHAMPION EDITION 001 冠軍限定香氛，數量售完即不再生產，敬請把握典藏機會。",
  },
  {
    question: "還有其他問題可以怎麼聯絡？",
    answer: "歡迎來信 info@mrearmusic.com，或致電 02-77094888。",
  },
]

function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <section id="faq" className="relative w-full bg-[#080808] px-8 py-28 md:px-16 md:py-40 lg:px-24">
      <motion.p
        className="font-sans-ui text-center text-[11px] tracking-[0.48em] text-[#c4a574]"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 1 }}
      >
        08
      </motion.p>

      <motion.h2
        className="font-display mt-6 text-center text-4xl text-[#f7f1e6] md:text-6xl"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 1.1, delay: 0.1 }}
      >
        常見問題
      </motion.h2>

      <div className="mx-auto mt-16 max-w-3xl border-t border-white/10">
        {FAQ_ITEMS.map((item, index) => {
          const isOpen = openIndex === index
          return (
            <motion.div
              key={item.question}
              className="border-b border-white/10"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, delay: index * 0.08 }}
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="flex w-full items-center justify-between gap-6 py-6 text-left"
                aria-expanded={isOpen}
              >
                <span className="font-serif-tc text-lg text-stone-100">
                  {item.question}
                </span>
                <span
                  className={`font-sans-ui shrink-0 text-lg text-[#c4a574] transition-transform duration-500 ${
                    isOpen ? "rotate-45" : "rotate-0"
                  }`}
                >
                  +
                </span>
              </button>
              <div
                className={`grid transition-all duration-500 ease-out ${
                  isOpen ? "grid-rows-[1fr] pb-8 opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
                style={{ display: "grid" }}
              >
                <div className="overflow-hidden">
                  <p className="font-sans-ui max-w-lg text-left text-[13px] leading-7 text-stone-400">
                    {item.answer}
                  </p>
                </div>
              </div>
            </motion.div>
          )
        })}
      </div>
    </section>
  )
}

export default FAQ
